// extracted by mini-css-extract-plugin
export var icon = "_3u-1";
export var subtext = "_3u-0";